module.exports = __webpack_public_path__ + "static/edmontonElksLogo-e50065e811e6c8f73ede1e1c2cb83446.png";